import { Button, Modal } from "antd";
import "./CreateFolderModal.scss";

export interface DesignInCartModalProps {
  isVisible: boolean;
  onClose: () => void;
  open: () => void;
}

export function DesignInCartModal({
                                    open, isVisible, onClose
}: DesignInCartModalProps) {

  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>The design is in your print cart</h2>
      </header>

      <p>
        If you proceed with this update, the design will be removed from your print cart. Click cancel to place your order before editing the design.
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={open}>
          Continue To Editor
        </Button>
      </footer>
    </Modal>
  );
}
